
import ContentBlockList from "@soenergy/frontend-library/src/components/ContentBlockList"
export default {
  name: `Page`,
  components: {
    ContentBlockList
  },
  props: {
    content: {
      required: true,
      type: Object
    }
  }
}
